// Shared bits for the stock value and cost reports (warehouse Phase 4).

/** "₹12,34,567" (rounded to the rupee); "—" when there is no value. */
export const formatINR = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  const sign = n < 0 ? '−' : '';
  return `${sign}₹${Math.abs(Math.round(n)).toLocaleString('en-IN')}`;
};

/** A rate per unit, up to 2 decimals ("₹412.5"); "—" when unpriced. */
export const formatRateINR = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return `₹${n.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
};

export const formatQty = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  return Number(value || 0).toLocaleString('en-IN', { maximumFractionDigits: 3 });
};

/** Stock movement types, in plain words (same wording as the server's MOVEMENT_LABELS). */
export const MOVEMENT_TYPE_LABELS = {
  opening: 'Opening stock',
  opening_edit: 'Opening stock corrected',
  revalue: 'Rate corrected',
  dispatch: 'Dispatched by vendor',
  grn: 'Received from PO',
  release: 'Released to site',
  return: 'Returned from site',
  audit_expired: 'Expired / damaged (audit)',
  audit_adjust: 'Audit count difference',
  manual_edit: 'Edited on Stock page',
  excel: 'Excel upload',
  transfer_out: 'Transferred to another warehouse',
  transfer_in: 'Transferred from another warehouse',
  lend_out: 'Lent to another project',
  lend_in: 'Borrowed from another project',
  lend_return_out: 'Borrowed stock returned',
  lend_return_in: 'Lent stock returned',
  short_close: 'PO closed short (in transit cleared)'
};

export const movementTypeLabel = (type) =>
  MOVEMENT_TYPE_LABELS[type] || String(type || '—').replace(/_/g, ' ');

/** Today as YYYY-MM-DD in the browser's time zone. */
export const todayISO = () => new Date().toLocaleDateString('en-CA');

/** The first day of this month as YYYY-MM-DD. */
export const monthStartISO = () => `${todayISO().slice(0, 7)}-01`;

/** This month as YYYY-MM. */
export const currentMonthKey = () => todayISO().slice(0, 7);

/** "2026-10" → "October 2026". */
export const formatMonthKey = (key) => {
  if (!/^\d{4}-\d{2}$/.test(String(key || ''))) return key || '—';
  const [y, m] = key.split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString('en-IN', { month: 'long', year: 'numeric' });
};
